"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseInt = void 0;
/**
 * Parsuje kolejne wartości, zwracając pierwszą, której można przypisać wartość typu int
 *
 * @export
 * @param {...any[]} values
 * @returns {number}
 */
function tryParseInt(...values) {
    for (const value of values) {
        const parsedValue = parseInt(value);
        if (!isNaN(parsedValue) && parsedValue.toString() === value.toString().replace(/^0+(?!$)/, '')) {
            return parsedValue;
        }
    }
}
exports.tryParseInt = tryParseInt;
//# sourceMappingURL=tryParseInt.js.map